/* Must be the first import in index.tsx: it runs before any module
   reads localStorage (the auth slice does so at import time). */
import { isDemoMode } from './demoMode';

const DESKTOP_QUERY = '(pointer: fine) and (min-width: 768px)';

const isDesktopBrowser = (): boolean => {
  try {
    return (
      !(window as any).ReactNativeWebView &&
      window.matchMedia(DESKTOP_QUERY).matches
    );
  } catch {
    return false;
  }
};

/** True while a non-desktop visitor is being sent from /demo back to /. */
export let demoRedirecting = false;

/* Demo state lives in sessionStorage under its own prefix, so it dies
   with the tab and never touches a real session on the same origin. */
const LS_PREFIX = 'tbx-demo:ls:';

const createSessionBackedStorage = (): Storage => {
  const ss = window.sessionStorage;
  const keys = (): string[] => {
    const out: string[] = [];
    for (let i = 0; i < ss.length; i++) {
      const k = ss.key(i);
      if (k?.startsWith(LS_PREFIX)) out.push(k.slice(LS_PREFIX.length));
    }
    return out;
  };
  return {
    get length() {
      return keys().length;
    },
    key: (i: number) => keys()[i] ?? null,
    getItem: (k: string) => ss.getItem(LS_PREFIX + k),
    setItem: (k: string, v: string) => ss.setItem(LS_PREFIX + k, String(v)),
    removeItem: (k: string) => ss.removeItem(LS_PREFIX + k),
    clear: () => keys().forEach((k) => ss.removeItem(LS_PREFIX + k)),
  };
};

if (isDemoMode) {
  if (!isDesktopBrowser()) {
    demoRedirecting = true;
    window.location.replace('/');
  } else {
    try {
      Object.defineProperty(window, 'localStorage', {
        value: createSessionBackedStorage(),
        configurable: true,
      });
    } catch (err) {
      console.error('[demo] Could not isolate localStorage', err);
    }
    document.documentElement.setAttribute('data-ui', 'v2');
  }
}
